import { createApi } from '@reduxjs/toolkit/dist/query/react';
import type {
    GetShippingProductsForCountryByWeightSpanAndSizeApiResponse,
    ShippingProductsForCountryByWeightSpanAndSizeRequest,
} from 'tradera/state/services/types/webapi-selling-generated';
import { isomorphicWebApiBaseQuery } from 'tradera/state/services/utils/webapi-base-query';
import qs from 'qs';

export const syiShippingApi = createApi({
    reducerPath: 'syiShippingApi',
    baseQuery: isomorphicWebApiBaseQuery,
    endpoints: (builder) => ({
        getShippingProducts: builder.query<
            GetShippingProductsForCountryByWeightSpanAndSizeApiResponse,
            ShippingProductsForCountryByWeightSpanAndSizeRequest
        >({
            query: (params) =>
                `/api/webapi/selling/shipping-products-for-country-by-weight-span-and-size?${qs.stringify(
                    params,
                )}`,
        }),
    }),
});
